// @ts-nocheck
import React, { useRef, useState, useReducer, useEffect } from 'react';
import {
  Paper,
  Chip,
  Slide,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Typography,
  TextField,
  Stack,
  IconButton,
} from '@mui/material';
import Alert from '@mui/material/Alert';


import {
  Link as RouterLink,
  // LinkProps as RouterLinkProps,
  MemoryRouter,
  Link,
} from 'react-router-dom';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import DateRange from '@mui/icons-material/DateRange';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import CarCrashIcon from '@mui/icons-material/CarCrash'; // diag
import CableIcon from '@mui/icons-material/Cable'; // connect
import BoltIcon from '@mui/icons-material/Bolt'; // fw
import ArchitectureIcon from '@mui/icons-material/Architecture'; // calib
import FaceIcon from '@mui/icons-material/Face'; // fw
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

import ArrowCircleDownTwoToneIcon from '@mui/icons-material/ArrowCircleDownTwoTone';
import LockResetIcon from '@mui/icons-material/LockReset';
import DownloadForOfflineTwoToneIcon from '@mui/icons-material/DownloadForOfflineTwoTone';
import EcuDiagChart, { EcuDiagChartComponentWrapper } from './EcuDiagChart';
import { EcuCalibBasic } from './EcuCalib';
import bigInt from 'big-integer'
import md5 from 'md5';


// ************************************************************
// ************************************************************
// ************************************************************

function EcuHistoryTableCellUser(props) {
  if (props.row.user_code == null) {
    // non ho le info sul pc, esempio perche' e' una riga di diagnosi
    return (
      <TableCell>
        <>&nbsp;</>
      </TableCell>
    )
  } else if (props.row.user_id == null) {
    // vista user, non ho le info sui pc degli altri utenti
    return (
      <TableCell>
        <Badge badgeContent={props.row.country} color="primary">
          <Button 
            variant="text"
            disabled
            >
            {props.row.user_code}            
          </Button>
        </Badge>        
      </TableCell>
    )
  } else {
    return (
      <TableCell>
        <Badge badgeContent={props.row.country} color="primary">
          <Button 
            // endIcon={<FaceIcon />}
            variant="text"
            target="_blank"
            rel="noopener noreferrer"
            icon={<BuildCircleIcon />} 
            component={RouterLink} to={"/service/user/details/"+props.row.user_id}
            >
            {props.row.username}            
          </Button>
        </Badge>        
      </TableCell>
    )
  }
}

function EcuHistoryTableCellComputer(props) {
  if (props.row.user_code == null) {
    // non ho le info sul pc, esempio perche' e' una riga di diagnosi
    return (
      <TableCell>
        <>&nbsp;</>
      </TableCell>
    )
  } else if (props.row.user_id == null) {
    // vista user, non ho le info sui pc degli altri utenti
    return (
      <TableCell>
        <Chip 
          variant="outlined" 
          color="default"
          icon={<BuildCircleIcon />} 
          label={props.row.program_name}
          />        
      </TableCell>
    )
  } else {
    return (
      <TableCell>
        <Chip 
          variant="outlined" 
          color="warning"
          label={props.row.program_name}
          target="_blank"
          rel="noopener noreferrer"
          clickable
          icon={<BuildCircleIcon />} 
          component={RouterLink} to={"/computer/list/code/"+props.row.user_code} 
          />        
      </TableCell>
    )
  }
}

function EcuHistoryTableCellAction(props) {
  const [open, setOpen] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)
  const handleOpen = () => { setOpen(true); }
  const handleOpen2 = () => { setOpen2(true); }
  const handleOpen3 = () => { setOpen3(true); }
  const handleClose = () => { setOpen(false); }
  const handleClose2 = () => { setOpen2(false); }
  const handleClose3 = () => { setOpen3(false); }
  switch (props.row._TBL) {
    default:
      return <></>

    case "conn":
      return (
        <>
          <TableCell align="center">
            <Tooltip title="CONNECTED" placement="top" arrow>
              <CableIcon color="action" style={{ fontSize: '48px' }} />
            </Tooltip>            
          </TableCell>
          <TableCell>&nbsp;</TableCell>
        </>
      )
    case "calib":
      return (
        <>
          <TableCell align="center">
            <Tooltip title="CAL UPDATED" placement="top" arrow>
              <ArchitectureIcon color="info" style={{ fontSize: '48px' }} />
            </Tooltip>
          </TableCell>
          <TableCell style={{whiteSpace: 'nowrap' }}>
            <EcuCalibDialog 
              calib_id={props.row.calib_id} 
              open={open} 
              onClickClose={handleClose} />
            <Stack direction="row" spacing={2} alignItems="center">
              <Chip 
                label={"CAL ID: " + props.row.calib_id} 
                color="info" 
                clickable
                onClick={handleOpen}                 
                />
              {/* <Chip 
                label={"CAL ID: " + props.row.calib_id} 
                color="info" 
                clickable
                target="_blank"
                rel="noopener noreferrer"
                component={RouterLink} to={"/ecu/calib/"+props.row.calib_id} 
                /> */}
              {(props.row.prev_calib_id !== 0) && (
                <Stack direction="row">
                  {(props.row.prev_calib_id !== 0) && (
                    <>
                      <EcuCalibDialog 
                        calib_id={props.row.calib_id} 
                        comp_calib_id={props.row.prev_calib_id} 
                        open={open2} 
                        onClickClose={handleClose2} />
                      <Tooltip title={"COMPARE WITH PREVIOUS (" + props.row.prev_calib_id + ")"} placement="top" arrow>
                        <IconButton 
                          // color="secondary"
                          clickable="true"
                          // target="_blank"
                          // rel="noopener noreferrer"
                          // component={RouterLink} to={"/ecu/calib/"+props.row.calib_id+"/"+props.row.prev_calib_id}
                          onClick={handleOpen2}                 
                          >
                          <ArrowCircleDownTwoToneIcon fontSize="large" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {(props.row.prev_calib_id !== 0) && (props.row.first_calib_id !== props.row.calib_id) && (
                    <>
                      <EcuCalibDialog 
                        calib_id={props.row.calib_id} 
                        comp_calib_id={props.row.first_calib_id} 
                        open={open3} 
                        onClickClose={handleClose3} />
                      <Tooltip title={"COMPARE WITH FIRST (" + props.row.first_calib_id + ")"} placement="top" arrow>
                        <IconButton 
                          // color="secondary"
                          clickable="true"
                          // target="_blank"
                          // rel="noopener noreferrer"
                          // component={RouterLink} to={"/ecu/calib/"+props.row.calib_id+"/"+props.row.first_calib_id}
                          onClick={handleOpen3}                 
                          >
                          <DownloadForOfflineTwoToneIcon fontSize="large" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </Stack>
              )} 
            </Stack>
          </TableCell>
        </>
      )

    case "fw": {
      return (
        <>
          <TableCell align="center">
            <Tooltip title="FW LOADED" placement="top" arrow>
              <BoltIcon color="warning" style={{ fontSize: '48px' }} />
            </Tooltip>
          </TableCell>
          <TableCell style={{whiteSpace: 'nowrap' }}>
            <Chip label={props.row.version} color="warning" />
          </TableCell>
        </>
      )
    }

    case "diag": {
      var diag_str = [
        "PINJ1",
        "PINJ2",
        "PINJ3",
        "PINJ4",
        "GINJ1",
        "GINJ2",
        "GINJ3",
        "GINJ4",
        "RAILPRESS_ELEC",
        "RAILPRESS_FUNC",
        "COLLPRESS_ELEC",
        "COLLPRESS_FUNC",
        "HWCODE_ERR",
        "TANK_EMPTY",
        "RAILTEMP_ELEC",
        "RAILTEMP_FUNC",
        "REDUCERTEMP_ELEC",
        "REDUCERTEMP_FUNC",
        "LEVELSENSOR_ELEC",
      ]
      //console.log(atob(props.row.header))
      var h = new Uint8Array(atob(props.row.header).split('').map(char => char.charCodeAt(0)));
      //console.log(h)      
      var diag_id = h[7]
      var diag_txt = (diag_id >= diag_str.length) ? null : diag_str[diag_id];
      var ecu_time = ( (h[11] << 24) | (h[10] << 16) | (h[9] << 8) | h[8] ) / 10;
      var ecu_time_txt = ""
      if (ecu_time < 60) { // meno di 1 minuto
        ecu_time_txt = ecu_time.toFixed(1) + " seconds"
      } else if (ecu_time < 60*60) { // meno di 1 ora
        ecu_time_txt = (ecu_time / 60).toFixed(1) + " minutes"
      } else if (ecu_time < 60*60*24) { // meno di 1 giorno
        ecu_time_txt = (ecu_time / (60*60)).toFixed(1) + " hours"
      } else { 
        ecu_time_txt = (ecu_time / (60*60*24)).toFixed(1) + " days"
      }
      //console.log(byteArray)
      return (
        <>
          <TableCell align="center">
            <Tooltip title="DIAG" placement="top" arrow>
              <CarCrashIcon color="error" style={{ fontSize: '48px' }} />
            </Tooltip>
          </TableCell>
          <TableCell style={{whiteSpace: 'nowrap' }}>
            {diag_txt == null ? <>&nbsp;</> : (
              <>                
                <EcuDiagChartDialog 
                  open={open} 
                  diag_buffer_id={props.row.id}
                  onClickClose={handleClose} />                                
                <Chip 
                  label={diag_txt} 
                  color="error" 
                  clickable
                  // target="_blank"
                  // rel="noopener noreferrer"
                  // component={RouterLink} 
                  // to={"/ecu/diag/buffer/"+props.row.id}
                  onClick={handleOpen} 
                  />
                &nbsp;
                <Button 
                  variant="text"
                  disabled
                  >
                  Ecu Time: {ecu_time_txt}
                </Button>
              </>
            )}
          </TableCell>
        </>
      )
    }

  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function EcuDiagChartDialog(props) {
  const [scroll, set_scroll] = React.useState('paper');
  const handleClose = () => { props.onClickClose(); }  
  return (    
    <div>      
      <Dialog
        open={props.open} 
        onClose={handleClose}
        fullScreen
        TransitionComponent={Transition} >
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}>
            <EcuDiagChart diag_buffer_id={props.diag_buffer_id} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleClose}>CLOSE</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function EcuCalibDialog(props) {
  const [scroll, set_scroll] = React.useState('paper');
  const handleClose = () => { props.onClickClose(); }  
  return (    
    <div>      
      <Dialog
        open={props.open} 
        onClose={handleClose}
        fullScreen
        TransitionComponent={Transition} >
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}>
            <EcuCalibBasic 
              calib_id={props.calib_id} 
              comp_calib_id={props.comp_calib_id} 
              />
          </DialogContentText>
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleClose}>CLOSE</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


const EcuHistoryTableCellTime = (props) => {
  const data = new Date(props.dataString)
  const opzioniFormattazione = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }
  const formatoItaliano = new Intl.DateTimeFormat('it-IT', opzioniFormattazione)
  const dataFormattata = formatoItaliano.format(data)     
  return (
    <TableCell style={{whiteSpace: 'nowrap' }} align="right" component="th" scope="row">
      {/* <Tooltip title={row.time} placement="right" arrow>
        <TimeAgo date={row.time} />                            
      </Tooltip> */}
      {dataFormattata}
    </TableCell>
  )
}

function getDayOfYear() {
  const currentDate = new Date();
  const startOfYear = new Date(currentDate.getFullYear(), 0, 0);
  const diff = currentDate - startOfYear;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  return dayOfYear;
}
function calc_pin(user_code, ecu_uid) {
    const dayOfYear = getDayOfYear(); 
    console.log("dayOfYear", dayOfYear)
    if (user_code.length !== 64 || ecu_uid.length !== 40) {
        return "";
    }
    var t1 = 
      user_code.toUpperCase() + 
      ecu_uid.toUpperCase() + 
      dayOfYear.toString(16).toUpperCase().padStart(8, '0')
    var t2 = md5(t1).toUpperCase()
    var t3 = t2.substring(4, 12).toUpperCase()
    console.log(t3)
    //const output = sum.toString(16).toUpperCase().padStart(8, '0');
    //console.log("PIN: " + output);
    var output = t3
    return output
}
export const UnlockPinDialog = (props) => {  
  const undef_str = "UNDEFINED"
  const [pin, setPin] = React.useState("")
  const [userCode, setUserCode] = React.useState("")
  const handleClose = () => { 
    setPin("")
    props.onClickClose(); 
  } 
  const handleGenerate = (e) => {  
    var o = calc_pin(userCode, props.ecu_uid)
    if (o === "")
      setPin(undef_str)
    else
      setPin(o)  
  }
  const handleUserCodeChange = (e) => {
    //console.log(e.target.value)
    setUserCode(e.target.value)
  }
  return (
    <>
      <div>      
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={props.open} 
          onClose={handleClose}
          TransitionComponent={Transition} >
          <DialogTitle>{"RESET LOCK PIN"}</DialogTitle>
          <DialogContent>
            <Stack sx={{ width: '100%' }} spacing={2}>
            <DialogContentText>
              Enter the user code of the computer that wants to unlock the ECU.
              <br />
              The generated PIN will be valid only today.
            </DialogContentText>
            <TextField
              autoFocus
              required
              //value={""}
              margin="dense"
              id="user_code"
              label="USER CODE"
              onChange={handleUserCodeChange}
              type="text"
              fullWidth
              variant="standard"
              // disabled={view_en.show_spin}
              />      
            {(pin === undef_str) ? (
              <Alert severity="error">{pin}</Alert>
            ) : (pin !== "") && (
              <Alert severity="success">{pin}</Alert>
            )}
            </Stack>
          </DialogContent>
          <DialogActions>          
            <Button onClick={handleGenerate}>GENERATE</Button>
            <Button onClick={handleClose}>CLOSE</Button>
          </DialogActions>
        </Dialog>
      </div>      
    </>
  )  
} 

export default function EcuHistoryTable(props) {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }
  var ecu_history
  var idx = 1
  if (props.ecu_history !== null && props.ecu_history !== undefined) {
    ecu_history = props.ecu_history.filter((row) => {
      if (row._TBL === "diag") {
        var h = new Uint8Array(atob(row.header).split('').map(char => char.charCodeAt(0)));
        const isAll255 = h.every(byte => byte === 255);
        if (isAll255)
          return undefined
      }
      return row
    })
    idx = ecu_history.length
  } 
  if (ecu_history === undefined) return <LoadingSpinner />
  if (ecu_history.length === 0) return <>NO INFO</> 

  var formatted_prod_data = ""
  if (props.prod_date !== "") {
    const prod_data = new Date(props.prod_date)
    const opzioniFormattazione = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }
    const formatoItaliano = new Intl.DateTimeFormat('it-IT', opzioniFormattazione)
    formatted_prod_data = formatoItaliano.format(prod_data)    
  }

  return (
    <>
      <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0 }}>
        <Typography variant="h4" gutterBottom>
          <Stack direction="row" alignItems="center" spacing={1}>
            ECU ID: {props.ecu_id}
            {(props.ecu_uid !== "") && (
              <>                
                <Tooltip title={"RESET LOCK PIN"} placement="top" arrow>
                  <IconButton 
                    clickable="true"
                    onClick={handleOpen}     
                    size="small"            
                  >
                    <LockResetIcon fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
                <UnlockPinDialog 
                  open={open} 
                  onClickClose={handleClose} 
                  ecu_uid={props.ecu_uid} 
                />
              </>
            )}
          </Stack>
          {(props.ecu_uid !== "") && (
            <Stack spacing={-1}>
              <Typography variant="overline" display="block" gutterBottom>
                PRODUCTION DATE:{' '}<Box component="span" sx={{ fontWeight: 'bold' }}>{formatted_prod_data}</Box>
              </Typography>
              <Typography variant="overline" display="block" gutterBottom>
                UID:{' '}<Box component="span" sx={{ fontWeight: 'bold' }}>{props.ecu_uid}</Box>                  
              </Typography>                            
            </Stack>
          )}
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="right">#</TableCell>
              <TableCell align="right">TIME</TableCell>
              <TableCell>USER</TableCell>
              <TableCell>ACTION</TableCell>
              <TableCell style={{ width: '100%' }} align="right">&nbsp;</TableCell>
              <TableCell>COMPUTER</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ecu_history.map((row) => (
              <TableRow
                key={idx--}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="right">
                  {/* row num */}
                  <Chip label={idx} size="small" variant="outlined" /> 
                </TableCell>
                <EcuHistoryTableCellTime dataString={row.time} />
                <EcuHistoryTableCellUser row={row} />
                <EcuHistoryTableCellAction row={row} />
                <EcuHistoryTableCellComputer row={row} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
